import React, { useState } from 'react';
import axios from 'axios';
import { Mail, ArrowRight, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';
import { BACKEND_URL } from '../lib/api';

const NotifyMeForm = () => {
  const [email, setEmail] = useState('');
  const [state, setState] = useState('idle'); // idle | submitting | done
  const [message, setMessage] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email.trim())) {
      toast.error('Please enter a valid email address.');
      return;
    }
    setState('submitting');
    try {
      const res = await axios.post(`${BACKEND_URL}/api/notify-me`, { email: email.trim() });
      setState('done');
      setMessage(
        res.data?.status === 'already_subscribed'
          ? "You're already on the list."
          : "You're in. We'll let you know when our first experience launches.",
      );
    } catch (err) {
      setState('idle');
      toast.error(err.response?.data?.detail || 'Could not subscribe right now.');
    }
  };

  if (state === 'done') {
    return (
      <div data-testid="notify-me-success" className="flex items-center gap-3 text-emerald-700 font-medium justify-center">
        <CheckCircle2 className="w-5 h-5" />
        <span>{message}</span>
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid="notify-me-form"
      className="flex flex-col sm:flex-row gap-2 max-w-md mx-auto"
    >
      <div className="relative flex-1">
        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
        <input
          type="email"
          required
          placeholder="you@vineyard.co.za"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="notify-me-email"
          className="w-full pl-9 pr-3 py-3 rounded-full border border-stone-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-[#1F3D2B]/30"
        />
      </div>
      <button
        type="submit"
        disabled={state === 'submitting'}
        data-testid="notify-me-submit"
        className="bg-[#1F3D2B] text-white rounded-full px-6 py-3 text-sm font-semibold hover:bg-[#2a5239] transition-colors disabled:opacity-60 inline-flex items-center justify-center gap-2"
      >
        {state === 'submitting' ? 'Submitting…' : 'Notify me'}
        {state !== 'submitting' && <ArrowRight className="w-4 h-4" />}
      </button>
    </form>
  );
};

export default NotifyMeForm;
